import React from 'react';
import './MapaMesas.css';
import { UtensilsCrossed, Users, Clock, CheckCircle } from 'lucide-react';

/**
 * Componente profesional para visualizar un mapa de mesas
 * @param {Array} mesas - Lista de mesas a mostrar
 * @param {Function} onMesaClick - Función a llamar cuando se hace clic en una mesa
 */
const MapaMesas = ({ mesas = [], onMesaClick }) => {
  return (
    <div className="mesa-map-container">
      <div className="mesa-map">
        {mesas.map((mesa) => {
          // Asegurar dimensiones mínimas y escalado proporcional
          const baseWidth = mesa.width || 1;
          const baseHeight = mesa.height || 60;
          const width = Math.max(baseWidth, 60);
          const height = Math.max(baseHeight, 60);

          // Determinar el estado de la mesa con lógica mejorada
          let estado = 'disponible';
          if (mesa.status === 'ocupada' || mesa.estado === 'ocupada') {
            estado = 'ocupada';
          } else if (mesa.status === 'pendiente' || mesa.estado === 'pendiente') {
            estado = 'pendiente';
          }

          // Usar los colores del CSS en lugar de los colores legacy
          const style = {
            left: `${mesa.posicionY || mesa.x || 0}px`,
            top: `${mesa.posicionX || mesa.y || 0}px`,
            width: `${width}px`,
            height: `${height}px`,
            fontWeight: mesa.negrita === '1' ? 'bold' : 'normal',
          };

          return (
            <div
              key={mesa.idMesa || mesa.id}
              className={`mesa-item ${estado}`}
              style={style}
              onClick={() => onMesaClick && onMesaClick(mesa)}
              title={`Mesa ${mesa.caption || mesa.nombre || mesa.numero} - ${estado.charAt(0).toUpperCase() + estado.slice(1)}`}
            >
              <div className="mesa-content-modern">
                <UtensilsCrossed size={14} className="mesa-icon" />
                <span className="mesa-numero-modern">
                  {mesa.caption || mesa.nombre || `${mesa.numero}` || 'Mesa'}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MapaMesas;